/** Short first phrase reduces time to first audio; all text is retained, including Unicode. */
export function speechChunks(text: string): string[] {
  let rest = text.trim();
  const chunks: string[] = [];
  while (rest) {
    const limit = chunks.length ? 1600 : 600;
    if (rest.length <= limit) { chunks.push(rest); break; }
    const prefix = rest.slice(0, limit);
    const boundaries = [...prefix.matchAll(/[.!?。！？](?:\s|$)|\n/g)];
    let end = boundaries.at(-1)?.index;
    end = end !== undefined && end >= limit / 3 ? end + 1 : prefix.lastIndexOf(" ");
    if (end < limit / 3) end = limit;
    // Do not split a UTF-16 surrogate pair.
    if (/[\uD800-\uDBFF]/.test(rest[end - 1])) end--;
    chunks.push(rest.slice(0, end).trim());
    rest = rest.slice(end).trim();
  }
  return chunks;
}

/** OpenAI PCM is signed little-endian 16-bit mono at 24 kHz. Network chunks may split samples. */
export function pcmSamples(chunk: Uint8Array, carry?: number): { samples: Float32Array; carry?: number } {
  const bytes = carry === undefined ? chunk : Uint8Array.from([carry, ...chunk]);
  const samples = new Float32Array(Math.floor(bytes.length / 2));
  for (let i = 0; i < samples.length; i++) {
    let sample = bytes[i * 2] | (bytes[i * 2 + 1] << 8);
    if (sample >= 32768) sample -= 65536;
    samples[i] = sample / 32768;
  }
  return { samples, carry: bytes.length % 2 ? bytes[bytes.length - 1] : undefined };
}
